import React from "react";
import { Col } from "react-bootstrap";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";

export default function EvaluationsToolbar({ date, onDateChange, selectedType, onTypeChange, types, typeDisabled, isMobile, showTypeSelector = true }) {
    const isMobileView = isMobile === 3;
    const rowClass = isMobileView ? "row mb-1" : "flex justify-content-start row mb-4";
    const calColProps = isMobileView ? { lg: 2, xs: 6 } : { lg: 2 };
    const calColClass = isMobileView
        ? "mb-2 d-flex justify-content-center align-items-center"
        : "flex justify-content-start row mb-4";

    return (
        <div className={rowClass}>
            <Col {...calColProps} className={calColClass}>
                <Calendar value={date} onChange={(e) => onDateChange(e.value)} view="year" dateFormat="yy" />
            </Col>
            {/* {showTypeSelector && (
                <Col {...(isMobileView ? { lg: 3, xs: 6 } : { lg: 3 })} className={isMobileView ? "mb-2 px-4 d-flex justify-content-center align-items-center" : "flex justify-content-start row mb-4 px-4"}>
                    <Dropdown
                        value={selectedType}
                        onChange={onTypeChange}
                        options={types}
                        disabled={typeDisabled}
                        optionLabel="title"
                        placeholder="Type"
                        className="w-full fw-semibold text-black"
                        style={{ maxWidth: "100%" }}
                    />
                </Col>
            )} */}
        </div>
    );
}
